if (!customElements.get('multicolumn-video-block')) {
  customElements.define('multicolumn-video-block', class MulticolumnVideoBlock extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.youtubeUrl;
      if (!url) return;

      const match = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);

      if (match && match[1]) {
        const iframe = this.querySelector('iframe');
        if (iframe) {
          iframe.src = `https://www.youtube.com/embed/${match[1]}`;
        }
      } else {
        const media = this.closest('.multicolumn-video__media');
        if (media) media.style.display = 'none';
      }
    }
  });
}
